export class AgendaState {
  constructor() {
    this.searchQuery = "";
    this.category = null;
    this.location = null;
    this.headerHeight = 0;
    
    this.listeners = [];
  }

  onStateChange(callback) {
    this.listeners.push(callback);
  }

  set(key, value) {
    if (this[key] === value) return;

    this[key] = value;
    this.listeners.forEach((callback) => callback(this));
  }
}